const navMenu = [
    {
        route: 'home'
    },
    {
        route: 'patients'
    },
    {
        route: 'admin'
    }
    // {
    //     route: 'test'
    // }
]

export default navMenu
